import React from "react";
import Classes from "./Button.scss";

const Button = ({children, clicked, name, theme ,disabled ,type ,style }) => {
  let classes;
  switch (theme) {
    case "primary":
      classes = "primary";
      break;
    case "submit":
      classes = "submit";
      break;
    case "white":
      classes = "white";
      break;
   
      case "danger":
        classes = "danger";
        break;
    default:
      classes = "primary";

      break;
  }

  return (
    <button className={`btnStyle ${classes}`} onClick={clicked} disabled={disabled} type={type} style={{...style}} >
      {name} {children}
    </button>
  );
};

export default Button;
